// ============================================================================
//  Setup wizard — pick-list options
// ============================================================================
//  Kept out of the step components so the same lists can be reused later by
//  the admin "Facility Settings" screen without copy-pasting them.

// Facility types recognised by the Ghana Health Service tiering the claims
// module already assumes elsewhere in the app.
export const FACILITY_TYPES = [
  'Clinic',
  'Health Centre',
  'Polyclinic',
  'Maternity Home',
  'Primary Hospital',
  'District Hospital',
  'Municipal Hospital',
  'Secondary Hospital',
  'Regional Hospital',
  'Teaching Hospital',
  'Specialized Hospital',
  'Community-Based Health Planning and Services (CHPS) compound',
  'Rehabilitation Center',
  'Diagnostic Centre',
  'Mobile Clinic (used in rural or outreach areas)',
  'Home Healthcare Service',
  'Military or Police Hospital',
  'Mission or Faith-Based Hospital',
  'National Centers for Medical Research and Advanced Procedure',
];

export const OWNERSHIP_TYPES = [
  'Government / Public',
  'Private',
  'Mission / Faith-Based',
  'Quasi-Government',
  'NGO',
  'Teaching Institution',
];

export const REGIONS = [
  'Ahafo Region',
  'Ashanti Region',
  'Bono Region',
  'Bono East Region',
  'Central Region',
  'Eastern Region',
  'Greater Accra Region',
  'North East Region',
  'Northern Region',
  'Oti Region',
  'Savannah Region',
  'Upper East Region',
  'Upper West Region',
  'Volta Region',
  'Western Region',
  'Western North Region',
];

export const GENDERS = ['Male', 'Female'];
